export default __webpack_public_path__ + "static/media/busque3.49797b76.png";